import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GovernanceRequestApi, ImmigrationProfileMiletones } from 'src/app/core/api.gen';
import { LoaderService } from 'src/app/core/loader.service';

@Component({
  selector: 'eos-governance-milestone',
  templateUrl: '../milestone/milestone.component.html',
  styleUrls: ['../milestone/milestone.component.css']
})
export class GovernanceMilestoneComponent implements OnInit {
  @Input() id: number;
  @Input() visaname: string;
  @Input() candidatename: string;

  mileStone: ImmigrationProfileMiletones[] = [];

  constructor(public modal: NgbActiveModal, private governanceApi: GovernanceRequestApi, private loader: LoaderService) { }

  ngOnInit() {
    this.loader.show();
    this.governanceApi.getGovernanceRequestMilestones(this.id)
      .subscribe(resp => {
        this.loader.clear();

        resp.forEach(x => x.milestoneTimeline = Number(Math.fround(x.milestoneTimeline / 24).toFixed(2)));

        this.mileStone = resp;
      },
      error => {
        this.loader.clear();
      });
  }

  legendStyle(satusId: number) {
    switch (satusId) {

      case 0: {
        return " timeline Not-Started"
      }
      case 1: {
        return " timeline In-Progress"
      }
      case 2: {
        return "timeline Not-Applicable"
      }
      case 3: {
        return "timeline Completed"
      }
    }
  }
}
